/* eslint-disable react/prop-types */

import React, { useState, useCallback } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  .sortable-item {
    transition: transform 0.2s, box-shadow 0.2s;
  }

  .sortable-item.dragging {
    opacity: 0.8;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    transform: scale(1.02);
    z-index: 1000;
  }

  .sortable-item.drag-over {
    border-top: 2px solid #3b82f6;
  }
`;

const SortableList = ({
  items,
  onReorder,
  renderItem,
  keyExtractor = (item, index) => item.id || index,
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  const handleDragStart = useCallback((e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', index.toString());
  }, []);

  const handleDragOver = useCallback((e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    
    if (draggedIndex !== null && draggedIndex !== index) {
      setDragOverIndex(index);
    }
  }, [draggedIndex]);

  const handleDragLeave = useCallback(() => {
    setDragOverIndex(null);
  }, []);

  const handleDrop = useCallback((e, dropIndex) => {
    e.preventDefault();
    
    if (draggedIndex === null || draggedIndex === dropIndex) {
      setDraggedIndex(null);
      setDragOverIndex(null);
      return;
    }

    const newItems = [...items];
    const [removed] = newItems.splice(draggedIndex, 1);
    newItems.splice(dropIndex, 0, removed);

    // Atualizar ordem
    const reorderedItems = newItems.map((item, index) => ({
      ...item,
      ordem: index + 1,
    }));

    onReorder(reorderedItems);
    setDraggedIndex(null);
    setDragOverIndex(null);
  }, [draggedIndex, items, onReorder]);

  const handleDragEnd = useCallback(() => {
    setDraggedIndex(null);
    setDragOverIndex(null);
  }, []);

  return (
    <Container>
      {items.map((item, index) => (
        <div
          key={keyExtractor(item, index)}
          className={`sortable-item ${draggedIndex === index ? 'dragging' : ''} ${dragOverIndex === index ? 'drag-over' : ''}`}
          draggable
          onDragStart={(e) => handleDragStart(e, index)}
          onDragOver={(e) => handleDragOver(e, index)}
          onDragLeave={handleDragLeave}
          onDrop={(e) => handleDrop(e, index)}
          onDragEnd={handleDragEnd}
        >
          {renderItem(item, index, draggedIndex === index)}
        </div>
      ))}
    </Container>
  );
};

export default SortableList;
